import React,{useState} from 'react';
import 'contents/assets/scss/page/mypage.scss';
import PopSendMail from '../_PopSendMail';
import ImgProfile from 'contents/assets/img/@profile.png';
const sampleImg = 'https://via.placeholder.com/90x70'
function SendMailDetail() {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <main className="com_container com_mail">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className='com_pg_tit icon menu12_5'>보낸 메일 <span className="bar"/><span className="point_txt">메일 상세보기</span></h2>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="user_info">
              <p className="thumb">
                <img src={ImgProfile} alt="profile" />
              </p>
              <div className="info_box">
                <p className="name">홍길동103 (123sdf@naver.com)</p>
                <p className="desc">안녕하세요 선생님 과학을 하고 있는 홍길동 입니다. …</p>
              </div>
              <div className="info_date">
                2023, 03, 25 13:45
              </div>
            </div>
          </section>
          <section className="box full">
            <section className="detail_box">
              <div className="top">
                <p className="tit">안녕하세요 선생님 과학을 하고 있는 홍길동 입니다. …</p>
                <div className="user_info">
                  <p className="thumb">
                    <img src={ImgProfile} alt="profile" />
                  </p>
                  <div className="info_box">
                    <p className="name">홍길동103 (123sdf@naver.com)</p>
                  </div>
                  <div className="info_date">
                    <p className="date">2023, 03, 25 13:45</p>
                    <div className="com_btn_wrap">
                      <button className="com_btn black s btn_like active">중요 메일</button>
                      <button className="com_btn black s btn_delete_orange">삭제하기</button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="contents">
                <div className="txt">
                  안녕하세요 선생님 과학을 하고 있는 홍길동 입니다. <br />
                  메일내용메일내용메일내용메일내용메일내용메일내용메일내용<br />
                  메일내용<br />
                  메일내용<br />
                  안녕하세요 선생님 과학을 하고 있는 홍길동 입니다. <br />
                  메일내용메일내용메일내용메일내용메일내용메일내용메일내용<br />
                  메일내용<br />
                  메일내용<br />
                  안녕하세요 선생님 과학을 하고 있는 홍길동 입니다. <br />
                  메일내용메일내용메일내용메일내용메일내용메일내용메일내용<br />
                  메일내용<br />
                  메일내용<br />
                  안녕하세요 선생님 과학을 하고 있는 홍길동 입니다. <br />
                  메일내용메일내용메일내용메일내용메일내용메일내용메일내용<br />
                  메일내용<br />
                  메일내용<br />
                  안녕하세요 선생님 과학을 하고 있는 홍길동 입니다. <br />
                  메일내용메일내용메일내용메일내용메일내용메일내용메일내용<br />
                  메일내용<br />
                  메일내용<br />
                  안녕하세요 선생님 과학을 하고 있는 홍길동 입니다. <br />
                  메일내용메일내용메일내용메일내용메일내용메일내용메일내용<br />
                  메일내용<br />
                  메일내용<br />
                </div>
              </div>
              <div className="attach_box">
                <div className="file">
                  <img src={sampleImg} alt="첨부파일이미지" />
                  <button className="btn_down_circle"></button>
                </div>
                <div className="file">
                  <img src={sampleImg} alt="첨부파일이미지" />
                  <button className="btn_down_circle"></button>
                </div>
              </div>
              <div className="com_btn_wrap center">
                <button className="com_btn orange xs">답장하기</button>
                <button className="com_btn line orange xs">전달하기</button>
              </div>
              <div className="re_box">
                <textarea className="textarea" placeholder='메일 답장 내용 입력'></textarea>
              </div>
              <div className="com_btn_wrap center">
                <button className="com_btn gray xs">메일 보내기</button>
              </div>
            </section>
          </section>
        </section>
      </div>
      <PopSendMail open={modalOpen} close={() => setModalOpen(false)} />
    </main>
  );
}

export default SendMailDetail;
